import { useEffect } from "react";
import './telegramLoginStyle.css';

const TelegramLogin = () => {
    const getCookie = (name) => {
        const match = document.cookie
          .split("; ")
          .find((row) => row.startsWith(name + "="));
      
        if (!match) return null; // Return null if cookie not found
  
        try {
          const rawValue = match.split("=")[1];
        //   console.log(`Raw cookie value for ${name}:`, rawValue);
          return decodeURIComponent(rawValue); // Properly decode it
        } catch (error) {
          console.error(`Error decoding cookie ${name}:`, error);
          return null; // Return null if decoding fails
        }
    }
    
    useEffect(() => {
        const loginToken = getCookie('data');
        // Ensure script is not already loaded
        if (document.getElementById("telegram-login-script")) return;

        // Dynamically insert Telegram login script
        const script = document.createElement("script");
        script.id = "telegram-login-script";
        script.src = "https://telegram.org/js/telegram-widget.js?22";
        script.setAttribute("data-telegram-login", "CommandCenterAlertsBot"); // Your bot username
        script.setAttribute("data-size", "medium");
        script.setAttribute("data-onauth", "onTelegramAuth(user)");
        script.setAttribute("data-request-access", "write");
        script.setAttribute("data-lang", "en");
        script.setAttribute("async", "true");

        // Append script inside a div
        document.getElementById("telegram-login-container").appendChild(script);

        // Define authentication function in global scope
        window.onTelegramAuth = async (user) => {
            // console.log("Telegram User Data:", user);
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            const addedTG = await fetch(`${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/profile/telegram/add`, {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify({
                    loginToken: loginToken,
                    telegramId: user.id
                })
            });

            if(addedTG.status === 200) alert("Successfully Connected Telegram account to your Command Center account");
            else alert("Something went wrong when connecting Telegram account with Command Center, Please try again."); 
        };
    }, []);

    return (
        <div className="telegram-login-container">
            {/* Telegram Login Button will render inside this div */}
            <div id="telegram-login-container"></div>
        </div>
    );
};

export default TelegramLogin;
